import { useState, useEffect } from 'react';
import { configService } from '@umanforge/common';
import { TaskAction } from 'interfaces/taskAction.interface';



const useTaskActionImages = ( taskActions: TaskAction[] ) => {

  const [ backendUrl, setBackendUrl ] = useState<string>( '' );
  const [ taskActionImages, setTaskActionImages ] = useState<Map<string, string | null>>( new Map() );
  const [ isFirstRender, setIsFirstRender ] = useState<boolean>( true );

  useEffect( () => {
    init();
  }, [] );

  const init = async () => {
    await configService.getBackendUrl().then( setBackendUrl );
    setIsFirstRender( false );
  };

  const fecthBlobs = async () => {
    const urls: Map<string, string> = new Map();
    taskActions.forEach( taskAction => {
      urls.set( taskAction.id, taskAction.icon );
    } );

    const keys: string[] = [];
    const promiseBlobs: Promise<Blob>[] = [];

    urls.forEach( ( value, key ) => {
      if ( value && backendUrl && !/^https?:\/\//.test( value ) ) {
        value = `${backendUrl}/${value.replace( /^\/+/, '' )}`;
      }
      if ( value ) {
        promiseBlobs.push( fetch( value, { credentials: 'include' } )
          .then( res => {
            //if ( !res.ok ) {throw new Error( `error while fetching image ${ value }` );}
            return res.blob();
          } )
          .catch()
        );
        keys.push( key );
      }
    } );

    const blobs = await Promise.all( promiseBlobs );

    const blobRes: Map<string, string | null> = new Map();
    for ( let index = 0; index < keys.length; index++ ) {
      blobRes.set( keys[ index ], URL.createObjectURL( blobs[ index ] ) );
    }
    setTaskActionImages( blobRes );
  };

  useEffect( () => {
    if ( !isFirstRender ) {
      fecthBlobs();

      return () => {
        if ( taskActionImages.size > 0 ) {
          taskActionImages.forEach( url => {
            if ( url ) {
              URL.revokeObjectURL( url );
            }
          } );
        }
      };
    }
  }, [ taskActions, backendUrl, isFirstRender ] );


  return taskActionImages;
};

export default useTaskActionImages;